module.exports = __webpack_public_path__ + "static/media/GalleryMain9.927538a6.jpg";